import React from 'react';
import styled from 'styled-components';
import GlobalStyle from '../Theme/GlobalStyle';
import Overlay from './Overlay';
import { isMobile } from '../Helpers';

export const StepSize = {
    height: 448,
    width: 320
};

const Wrapper = styled.aside`
    grid-template-rows: ${props => props.gridRowTemplate || '64px 4px 320px 64px'};
    height: ${StepSize.height}px;
    ${props => props.yAdjustment}
    ${props => props.xAdjustment}
    width: ${StepSize.width}px;
`;

const Step = ({ backgroundColor, children, isModal, showFooter, size, textColor, xPosition, yPosition }) => {
    const mobile = isMobile();
    let yAdjustment = '',
        xAdjustment = 'margin-left: 0px;';
    if (isModal) {
        yAdjustment = `position: relative; top:  calc(10.5rem + 1vh); margin-top: -${StepSize.height / 2}px;`;
        xAdjustment = `margin-left: -${StepSize.width / 2}px;`;
    } else {
        yAdjustment = yPosition === 'bottom' ? 'margin-top:-432px;position:absolute;bottom:16px;' : '';

        switch (xPosition) {
            case 'middle':
                xAdjustment = `left:-125px; margin-left: -${StepSize.width / 2}px;`;
                break;
            case 'right':
                xAdjustment = `margin-left:-${StepSize.width}px; right:0;`;
                break;
        }
    }

    return isModal ? (
        <>
            <GlobalStyle brandPrimary={backgroundColor} brandText={textColor} />
            <Overlay>
                <Wrapper
                    className="clx-step modal"
                    gridRowTemplate={showFooter ? '64px 4px 320px 64px' : '64px 4px 380px'}
                    yAdjustment={yAdjustment}
                    xAdjustment={xAdjustment}
                >
                    {children}
                </Wrapper>
            </Overlay>
        </>
    ) : (
        <>
            <GlobalStyle brandPrimary={backgroundColor} brandText={textColor} />
            <Wrapper
                className="clx-step"
                gridRowTemplate={showFooter ? '64px 4px 320px 64px' : '64px 4px 380px'}
                yAdjustment={yAdjustment}
                xAdjustment={xAdjustment}
            >
                {children}
            </Wrapper>
        </>
    );
};

export default Step;
